import { memo } from 'react';

import classNames from 'classnames';

import { type ConnectorField, ConnectorFieldFormItem } from '@/entities/connector';

import styles from './ConnectorConfigFields.module.css';

const SCHEMA_LOADING_MESSAGE = '커넥터 설정 스키마 로딩 중...';
const SCHEMA_ERROR_MESSAGE = '커넥터 설정 스키마를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';

type ConnectorConfigFieldsProps = {
  fields: readonly ConnectorField[];
  isLoading: boolean;
  isError: boolean;
  disabled?: boolean;
  showConfigJson: boolean;
};

const ConnectorConfigFields = memo(
  ({ fields, isLoading, isError, disabled, showConfigJson }: ConnectorConfigFieldsProps) => {
    return (
      <div className={classNames(styles.configSection, { [styles.hidden]: showConfigJson })}>
        {!isError && isLoading && (
          <p className={styles.stateMessage} role="status" aria-live="polite" aria-atomic="true">
            {SCHEMA_LOADING_MESSAGE}
          </p>
        )}

        {isError && (
          <p className={styles.stateMessageError} role="alert">
            {SCHEMA_ERROR_MESSAGE}
          </p>
        )}

        {!isError &&
          !isLoading &&
          fields.map((field) => (
            <ConnectorFieldFormItem
              key={field.label}
              field={field}
              disabled={disabled}
              className={styles.configFieldItem}
            />
          ))}
      </div>
    );
  }
);

ConnectorConfigFields.displayName = 'ConnectorConfigFields';

export { ConnectorConfigFields };
